var _rect, _path, _circle, _circle2, _circle3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnakeArcade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 40,
    fill: "#12142b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 290h120v-90h120v90h120v-90h120",
    fill: "none",
    stroke: "#55e39f",
    strokeWidth: 58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 200,
    r: 31,
    fill: "#b8ffdc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 190,
    r: 5,
    fill: "#12142b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 110,
    r: 30,
    fill: "#ffcb45"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 400,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "sans-serif",
    fontSize: 62,
    fontWeight: 800
  }, "NEON SNAKE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnakeArcade);
export default __webpack_public_path__ + "static/media/snake_arcade.0b335623fef83a60f4213664a5dec239.svg";
export { ForwardRef as ReactComponent };